<template>
    <div class="block-editor assign-owner">
        <section>
            <div class="title">Algoritma</div>
            <a-select v-model="clone.algorithm" class="classic-select">
                <a-select-option value="least_contact">En Az Kontağa Sahip Olan</a-select-option>
                <a-select-option value="random">Rastgele</a-select-option>
            </a-select>
        </section>
        <section>
            <div class="title">Tarih Aralığı</div>
            <a-select v-model="clone.dateRange" class="classic-select">
                <a-select-option value="today">Bugün</a-select-option>
                <a-select-option value="last_7_days">Son 7 Gün</a-select-option>
                <a-select-option value="last_30_days">Son 30 Gün</a-select-option>
            </a-select>
            <small>Temsilcilerin sahip olduğu kontak sayılarına bakılacak zaman aralığı</small>
        </section>
        <section>
            <div class="title">Sadece Online Olanlara Dağıt</div>
            <a-switch v-model="clone.checkOnlineStatus" />
        </section>
        <section>
            <div class="title">Hariç Tutulacak Temsilciler</div>
            <a-select v-model="clone.excludeUserIds" mode="multiple" class="classic-select">
                <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
            <small>Seçilen temsilciler atama havuzundan hariç tutulacaktır</small>
        </section>

        <section>
            <div class="title">Zoho CRM Senkronizasyonu</div>
            <a-switch v-model="clone.syncOnZoho" />
            <small>
                Atanan kullanıcı Zoho CRM'de senkronize edilecektir.
            </small>
        </section>

    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";

export default {
    name: "AssignOwner",
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
    created() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.assign-owner {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .classic-select {
        width: 100%;
    }

    small {
        color: #777;
    }
}
</style>
